import { CitizenshipIdEnum } from "../../../../../enum/auth";

export const isRussianChar = (char: string): boolean => {
  return /[а-яёА-ЯЁ\s-]/.test(char);
};

export const isLatinChar = (char: string): boolean => {
  return /[a-zA-Z\s-]/.test(char);
};

export const isValidCharForRuPassport = (char: string): boolean => {
  return isRussianChar(char);
};

export const isValidCharForForeignPassport = (char: string): boolean => {
  return isRussianChar(char) || isLatinChar(char);
};

export const validateInputByPassportType = (
  input: string,
  citizenshipId: number | null
): { isValid: boolean; errorMessageKey: string } => {
  if (!input.trim()) {
    return { isValid: true, errorMessageKey: '' };
  }

  if (citizenshipId === CitizenshipIdEnum.Russian) {
    const hasNonRussianChars = input
      .split('')
      .some(char => !isValidCharForRuPassport(char));

    if (hasNonRussianChars) {
      return {
        isValid: false,
        errorMessageKey: "passport.registrationForm.validation.cyrillic_only"
      };
    }
  } else if (citizenshipId === CitizenshipIdEnum.Foreign) {
    const hasInvalidChars = input
      .split('')
      .some(char => !isValidCharForForeignPassport(char));

    if (hasInvalidChars) {
      return {
        isValid: false,
        errorMessageKey: "passport.registrationForm.validation.cyrillic_or_latin_only"
      };
    }
  }

  return { isValid: true, errorMessageKey: '' };
};
